/**
 * Version: 1.0.0
 * Author: M2MBA
 * Last Updated: 2026-07-30
 * Description: Central design-system theme selector (ease | legacy) for rollback
 */

export type DesignSystemId = 'ease' | 'legacy'

/**
 * Active design system for the student-browsing app.
 * Switch to `'legacy'` to restore the previous Structured Innovation (dark) look.
 *
 * Rollback checklist:
 * 1. Set this constant to `'legacy'`
 * 2. Optionally update the bootstrap script in `index.html` (`data-design-system`)
 * 3. Homepage automatically switches to `HomePageLegacy`
 * Snapshot of prior tokens/CSS/home-v2:
 * `public/demos/design-system-structured-innovation-2026-07/`
 */
export const ACTIVE_DESIGN_SYSTEM: DesignSystemId = 'ease'

export const isEaseTheme = (id: DesignSystemId = ACTIVE_DESIGN_SYSTEM) => id === 'ease'
export const isLegacyTheme = (id: DesignSystemId = ACTIVE_DESIGN_SYSTEM) => id === 'legacy'
